import ViewDetails from "../../utils/utilities/ViewDetails";

import { Tab } from "@mui/material";

import GenericTab from "../../utils/utilities/GenericTab";

// NewEvent Context
import { NewEventProvider } from "../../contexts/NewEvent";

import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import StyleOutlinedIcon from '@mui/icons-material/StyleOutlined';
import ContentCutRoundedIcon from '@mui/icons-material/ContentCutRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import AddCardIcon from '@mui/icons-material/AddCard';
import PaidRoundedIcon from '@mui/icons-material/PaidRounded';


// Tabs
import ProfileTab from "./Tabs/Profile";
import AppointmentTab from "./Tabs/Appointments";
import MessagesTab from "./Tabs/Messages";
import Invoices from "./Tabs/Invoices";
import PaymentsTab from "./Tabs/Payments";
import CardTab from "./Tabs/Cards";
import CustomerWigsTab from "./Tabs/Wigs";
// import SecurityTab from "./Tabs/Security";



  const tabContent = [
    {panel: "profile", content: <ProfileTab />},
    {panel: "appointments", content: <AppointmentTab />},
    {panel: "invoices", content: <Invoices />},
    {panel: "payments", content: <PaymentsTab />},
    {panel: "wigs", content: <CustomerWigsTab />},
    // {panel: "repairs", content: <GenericTab />},
    {panel: "messages", content: <MessagesTab />},
    // {panel: "custom_orders", content: <GenericTab />},
    // {panel: "saved_cards", content: <CardTab />},
    // {panel: "security", content: <SecurityTab />}
  ]

const ViewCustomer = () => {

  const tabs = [
    {label: "Profile", icon: <ContactPageOutlinedIcon fontSize="small" />},
    {label: "Appointments", icon: <CalendarMonthRoundedIcon fontSize="small" />},
    {label: "Invoices", icon: <ReceiptLongRoundedIcon fontSize="small" />},
    {label: "Payments", icon: <PaidRoundedIcon fontSize="small" />},
    {label: "Customer Wigs", icon: <AutoAwesomeOutlinedIcon fontSize="small" />},
    // {label: "Repairs", icon: <ContentCutRoundedIcon fontSize="small" />},
    {label: "Messages", icon: <ForumOutlinedIcon fontSize="small" />},
    // {label: "Custom Orders", icon: <StyleOutlinedIcon fontSize="small" />},
    // {label: "Saved Cards", icon: <AddCardIcon fontSize="small" />}
  ];

  return (
    <NewEventProvider>
      <ViewDetails title="Customer" identifier="full_name" tabs={tabs} tabContent={tabContent} isProfile={true} url="customers">

      </ViewDetails>
    </NewEventProvider>
  )
};

export default ViewCustomer;